import { makeStyles } from '@mui/styles';

export default makeStyles((theme) => ({
	tabContainer: {},
	tabList: {
		width: 'fit-content',
		border: `1px solid ${theme.palette.primary.grey}`,
		borderRadius: '.5rem',
		'& span': {
			visibility: 'hidden'
		},
		'& .Mui-selected': {
			backgroundColor: `${theme.palette.primary.lightOne} !important`
		},
		'& .Mui-selected:nth-child(n+2):nth-last-child(n+2)': {
			backgroundColor: `${theme.palette.primary.lightOne} !important`,
			borderLeft: `.5px solid ${theme.palette.primary.main}`,
			borderRight: `.5px solid ${theme.palette.primary.main}`
		},
		'& .Mui-selected:nth-child(1)': {
			borderRight: `.5px solid ${theme.palette.primary.main}`
		},
		'& .Mui-selected:nth-last-child(1)': {
			borderLeft: `.5px solid ${theme.palette.primary.main}`
		}
	},
	singularTab: {
		'& .Mui-selected:nth-child(1)': {
			border: '0px'
		}
	},
	tabIndicator: {},
	tabPanel: {}
}));
